import type { Component } from 'solid-js'
import type { ChatTimeSeriesData } from '../../../features/engagement/domain/models/chat'
import { ChartContainer, ChartLegend, useChartWithLegend, useLegendState } from '../charts'
import { getChatChartOptions, CHAT_LEGEND_ITEMS, CHAT_INITIAL_LEGEND_STATE, type ChatLegendState } from './ChatChart.vm'

interface ChatChartProps {
  data: ChatTimeSeriesData[]
  showActiveUsers?: boolean
  showTotalMessages?: boolean
  showUniqueChatters?: boolean
}

const ChatChart: Component<ChatChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const initialState: ChatLegendState = {
    activeUsers: props.showActiveUsers ?? CHAT_INITIAL_LEGEND_STATE.activeUsers,
    totalMessages: props.showTotalMessages ?? CHAT_INITIAL_LEGEND_STATE.totalMessages,
    uniqueChatters: props.showUniqueChatters ?? CHAT_INITIAL_LEGEND_STATE.uniqueChatters
  }

  const { state: legendState, toggle } = useLegendState(initialState)

  const visibleLegendItems = () => {
    return CHAT_LEGEND_ITEMS.filter((item) => {
      if (item.key === 'activeUsers') return props.showActiveUsers !== false
      return true
    })
  }

  useChartWithLegend({
    data: () => props.data,
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getChatChartOptions(data, legend)
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <ChartLegend items={visibleLegendItems()} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default ChatChart
